'use strict';
define([
    './util',
    '../data/config/app',
    './navigation/CountryLinks'
], function (util, config, CountryLinks) {
    return {
        init: function () {
            this.geooverlay = document.querySelector('.navigation-geooverlay');
            this.countryNameFlag = document.querySelector('.navigation-geooverlaycountryname');
            this.countryLink = document.querySelector('.navigation-geooverlay a');
            this.closeBtn = document.querySelector('.navigation-navgeooverlayclose');
            this.miniBagOverlay = document.querySelector('.navigation-minibag-dock-overlay');
            this.headerVersion = document.querySelector('#nav-primary__header-version').innerText;
            this.hostC = (config.storeId === '10151') ? 'UK' : 'IE';
            this.buildOverlay = this.buildOverlay.bind(this);
            this.closeGeo = this.closeGeo.bind(this);
            this.trackClick = this.trackClick.bind(this);
            this.checkGeoLocation = this.checkGeoLocation.bind(this);
            this.checkGeoLocation();
        },
        checkGeoLocation: function () {
            var originCountryX = document.cookie.match('MS_ORIGIN_COUNTRY')?document.cookie.match('MS_ORIGIN_COUNTRY').input : false;
            var originCountryY = originCountryX ? originCountryX.indexOf('MS_ORIGIN_COUNTRY=') : -1;
            this.originCountry = originCountryY !== -1 ? originCountryX[originCountryY + 18] + originCountryX[originCountryY + 19] : false;
            if (this.originCountry && (config.storeId === '10151' && this.originCountry !== 'GB') || (config.storeId === '10451' && this.originCountry !== 'IE')) {
                if (window && window.localStorage && (window.localStorage.navoriginCountry !== this.originCountry || window.localStorage.navOriginHeaderVersion !== this.headerVersion)) {
                    CountryLinks.loadCountryData(this.buildOverlay);
                    window.localStorage.navOriginCountryName = '';
                    window.localStorage.navOriginCountryUrl = '';
                    window.localStorage.navOriginHeaderVersion = '';
                }
                else if (window && window.localStorage && window.localStorage.navOriginCountryName && window.localStorage.navOriginCountryUrl) {
                    this.countryNameFlag.innerHTML = '<i id="navigation-flags-overlay-geo" class="navigation-flags-overlay navigation-flags-overlay--' + this.originCountry + '" style="background-image: url(' + window.localStorage.navoriginCountryFlag + ');"></i>' + window.localStorage.navOriginCountryName + '?';
                    var cLink = window.localStorage.navOriginCountryUrl + '?extid=' + this.hostC.toLowerCase() + '_header_country-redirect_' + this.originCountry.toLowerCase() + '_countrybanner';
                    this.countryLink.href = cLink;
                    util.removeClass(this.geooverlay, 'navigation-geooverlay--hidden');
                    util.addClass(this.miniBagOverlay, 'navgeominibag');
                    window.HIDE_MS_COMMON_HDR_STICKY = true;
                    this.closeBtn.addEventListener('click', this.closeGeo);
                    this.countryLink.addEventListener('click', this.trackClick);
                } else {
                    CountryLinks.loadCountryData(this.buildOverlay);
                }

                /*eslint-disable*/
                var utag_link_data = {
                    link_name: 'country selector banner:open',
                    product_lightbox: 'country selector banner',
                    country_selected: this.hostC.toLowerCase(),
                    language_selected: 'english',
                    event_name: 'generic_lightbox_open'
                };
                if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
                    utag.link(utag_link_data);
                }
                /*eslint-enable*/
            }
        },
        buildOverlay: function (data) {
            var countryData = data.countryLinks;
            if (countryData) {
                for (var countryI = 0; countryI < countryData.length; countryI++) {
                    if (this.originCountry === countryData[countryI].name) {
                        this.countryNameFlag.innerHTML = '<i id="navigation-flags-overlay-geo" class="navigation-flags-overlay navigation-flags-overlay--' + this.originCountry + '" style="background-image: url(' + data.countryFlagLink + ');"></i>' + data.countryLinks[countryI].imgPath + '?';
                        var cLink = countryData[countryI].url + '?extid=' + this.hostC.toLowerCase() + '_header_country-redirect_' + this.originCountry.toLowerCase() + '_countrybanner';
                        this.countryLink.href = cLink;
                        window.localStorage.navoriginCountry = this.originCountry;
                        window.localStorage.navOriginCountryName = data.countryLinks[countryI].imgPath;
                        window.localStorage.navOriginCountryUrl = data.countryLinks[countryI].url;
                        window.localStorage.navoriginCountryFlag = data.countryFlagLink;
                        window.localStorage.navOriginHeaderVersion = this.headerVersion;
                        util.removeClass(this.geooverlay, 'navigation-geooverlay--hidden');
                        util.addClass(this.miniBagOverlay, 'navgeominibag');
                        window.HIDE_MS_COMMON_HDR_STICKY = true;
                        this.closeBtn.addEventListener('click', this.closeGeo);
                        this.countryLink.addEventListener('click', this.trackClick);

                    }
                }
            }
        },
        closeGeo: function () {
            util.addClass(this.geooverlay, 'navigation-geooverlay--hidden');
            util.removeClass(this.miniBagOverlay, 'navgeominibag');
            var session = 'MS_PREFERRED_COUNTRY';
            window.sessionStorage[session] = (config.storeId === '10151') ? 'GB' : 'IE';
            window.HIDE_MS_COMMON_HDR_STICKY = false;
            /*eslint-disable*/
            if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
                utag.link({ link_name: 'header:country redirect banner:close', generic_lightbox: 'header:country redirect:' + this.originCountry.toLowerCase(), event_name: 'generic_lightbox_close' });
            }
            /*eslint-enable*/
        },
        trackClick: function (evt) {
            evt.preventDefault();
            /*eslint-disable*/
            if (typeof utag !== 'undefined' && typeof utag.link === 'function') {
                utag.link({ link_name: 'header:country redirect banner:submit', generic_lightbox: 'header:country redirect:' + this.originCountry.toLowerCase(), event_name: 'generic_lightbox_close' });
            }
            /*eslint-enable*/
            setTimeout(function () {
                window.location = document.querySelector('.navigation-geooverlay a').href;
            }, 100);
        }
    };
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/GeoOverlay.js